<template>
    <a id="spaceAnchor"></a>
    <section class="space-card__section" v-if="variationImages && variationImages.length > 0">
        <div class="space-card__left">
            <div id="carouselExampleControls" class="space-card__carousel carousel slide carousel-fade">
                <div class="carousel-inner">
                    <div v-for="(image, index) in variationImages" :key="image.identifier"
                        class="carousel-item"
                        :class="{ 'active': activeCarouselStep === index}"
                    >
                        <img :src="`https://spacebarprod-16905.kxcdn.com/public-assets/${image.slug}?size=desktop`"
                            loading="lazy"
                            class="space-card__carouse-img d-block w-100"
                            :alt="image.alt"
                        >
                    </div>
                </div>
                <button v-if="variationImages.length > 1" @click.prevent="updateActiveCarouselStep('decrease')" class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button v-if="variationImages.length > 1" @click.prevent="updateActiveCarouselStep('increase')" class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
                </div>
        </div>
        <div class="space-card__right" >
            <div class="space-card__bold">{{ spaceOptionsTitleLabel }}</div>
            <div class="d-flex flex-wrap justify-content-around">
                <div
                    v-for="sku in product.relationships.product.skus" :key="sku.id"
                    @click="activeSku = sku"
                    class="btn space-card__office-button"
                    :class="{'space-card__office-button-active': activeSku.title == sku.title }"
                >
                {{sku.title}}
            </div>
            </div>

            <template v-if="productSlug == 'meeting-space'">
                <div class="row">
                    <div class="col-md-6">
                        <label for="spots" class="space-card__bold">{{ peopleTitleLabel }}</label>
                        <input id="spots" class="form-control text-center" v-model="spots" type="number" :min="variationDescription.min_people_spaces_restriction" :max="variationDescription.max_people_spaces_restriction">
                    </div>
                    <div class="col-md-6">
                        <label for="hours" class="space-card__bold">{{ hoursTitleLabel }}</label>
                        <input id="hours" class="form-control text-center" v-model="hours" type="number" min="2">
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="col-12">
                        <label for="food" class="space-card__bold">{{ foodTitleLabel }}</label>
                        <select name="food" id="food" v-model="foodOption" class="form-control">
                            <option value="none" disabled selected>{{ defaultSelectOption }}</option>
                            <option value="Snack menu">Snack menu</option>
                            <option value="Snack menu 2">Snack menu 2</option>
                        </select>
                    </div>
                </div>
            </template>

            <div class="space-card__bold mt-3">{{ descriptionTitleLabel }}</div>
            <div class="space-card__muted" v-html="variationDescription.small_description" v-if="variationDescription && variationDescription.small_description"></div>
            <div class="d-flex flex-column flex-wrap mb-2" >
                <div class="space-card__bold">
                  {{ locale == 'en' ? 'From' : 'Desde' }}
                </div>
                <div class="d-flex flex-wrap">
                  <div class=" text-nowrap me-2 d-flex align-items-end gap-2">
                    <p class="space-price mb-1">${{ skuData.price.toLocaleString("en", {useGrouping: true}) }} </p>
                    <div style="font-size: 20px;font-weight: 600;color: rgb(100,100,100);" class="d-flex mb-2">
                      {{skuData.currency}} 
                      <p class=" d-flex align-items-center mb-0" style="font-size: 20px;font-weight: 600;color: rgb(100,100,100);"
                          v-html="'/ '+productPeriodicity('long') + (variationDescription?.minimum_contract_timeframe? '*' : '') "
                      >
                      </p>
                    </div> 
                  </div>
                  
                <span class="space-card__italic-muted" v-if="product.slug.includes('meeting-space')">
                  {{ locale === 'es' ? '*$20 USD / hora adicional' : '*$20 USD / additional hour' }}
                </span>
                </div>


            </div>

            <template v-if="!spaceNotAvailable">
                <div class="d-flex mb-2">
                    <a :href="urlQueryString" class="button-space px-5" style="min-width:240px">
                        {{ locale == 'en' ? 'Hire now' : 'Contrata ahora' }}
                    </a>
                </div>
                <span class="space-card__italic-muted">
                    {{ variationDescription?.minimum_contract_timeframe }}
                </span>
            </template>
        </div>
    </section>
</template>

<script>
import spaceMixin from '../space-mixin'
import { defineComponent } from 'vue'
import { Carousel, Navigation, Slide } from 'vue3-carousel'


export default defineComponent({
  inject: ['locale'],
  mixins: [spaceMixin],
  props: {
      product: Object,
      variations: Array
  },
  components: {
      Carousel,
      Slide,
      Navigation,
  },
  data() {
    return {
      activeSku: null,
      activeCarouselStep: 0,
      spots: 1,
      hours: 2,
      foodOption: 'none'
    }
  },
  created(){
      this.activeSku = product.relationships.product.skus[0];
  },
  watch: {
    activeSku(){
      this.activeCarouselStep = 0;
    },
    spots() {
      if (this.spots < this.variationDescription.min_people_spaces_restriction) {
        this.spots = this.variationDescription.min_people_spaces_restriction;
      }
      if (this.spots > this.variationDescription.max_people_spaces_restriction) {
        this.spots = this.variationDescription.max_people_spaces_restriction;
      }
    },
    hours() {
      if (this.hours < this.variationDescription.min_hours_restriction) {
        this.hours = this.variationDescription.min_hours_restriction;
      }
      if (this.hours > this.variationDescription.max_hours_restriction) {
        this.hours = this.variationDescription.max_hours_restriction;
      }
    }
  },
  computed: {
    variationImages() {
      let selectedSpace = this.product.space_details_for_variations.find( x => x.identifier == this.activeSku.title)
      return (selectedSpace && selectedSpace.images) ? selectedSpace.images : []
    },
    variationDescription() {
      let selectedSpace = this.product.space_details_for_variations.find( x => x.identifier == this.activeSku.title)
      return selectedSpace
    },
    skuData(){
      return product.relationships.product.skus.find( x => x.title == this.activeSku.title)
    },
    productSlug() {
      return this.product && this.product?.slug ? this.product.slug : '#';
    },
    urlQueryString() {
      let url = null;
      let sku = this.activeSku?.title || 'none';
      let spots = this.spots ? this.spots : 1;
      let hours = this.hours ? this.hours : 1;
      let foodOption = this.foodOption ? this.foodOption : 'none';
      url = `/${this.locale}/checkout/${this.productSlug}?sku=${sku}&spaces=${spots}&hours=${hours}&foodOption=${foodOption}`
      return url;
    },
    spaceOptionsTitleLabel() {
      if (this.productSlug === 'meeting-space') {
          return  locale == 'en' ? 'Choose your room' : 'Elige tu sala'
      }
      if (this.productSlug === 'team-space') {
          return  locale == 'en' ? 'Choose your office' : 'Elige tu oficina'
      }
      return '';
    },
    peopleTitleLabel() {
      return this.locale === 'es' ? 'Personas / lugares' : 'People / spaces';
    },
    hoursTitleLabel() {
      return this.locale === 'es' ? 'Horas' : 'Hours';
    },
    foodTitleLabel() {
      return this.locale === 'es' ? 'Alimentos' : 'Snacks';
    },
    descriptionTitleLabel() {
      if (this.spaceNotAvailable) return this.locale == 'es' ? 'Oficina no disponible' : 'Space not available'

      return this.locale == 'es' ? 'Descripción' : 'Description'
    },
    defaultSelectOption() {
      return this.locale === 'es' ? 'Seleccione una opción' : 'Select an option';
    },
    spaceNotAvailable() {
      let variationCurrentLocale = this.variations?.find(v => v.sku === this.activeSku.sku)
      let variationOtherLocale = this.variations?.find(v => v.sku === this.replaceSku(this.activeSku.sku))

      let currentNotAvailable = variationCurrentLocale?.relationships?.inventories?.find(i => i?.on_hand <= 0)
      let otherNotAvailable = variationOtherLocale?.relationships?.inventories?.find(i => i?.on_hand <= 0)

      return otherNotAvailable || currentNotAvailable
    }
  },
  methods: {
      updateActiveCarouselStep(action) {
          const myVar = document.querySelector('#my-element');
          const leftArrow = document.querySelector('.carousel-control-prev')
          const rightArrow = document.querySelector('.carousel-control-next')

          if (action == 'increase') {
              this.activeCarouselStep = (this.activeCarouselStep == this.variationImages.length - 1) ? 0 : this.activeCarouselStep + 1
          } else {
              this.activeCarouselStep = this.activeCarouselStep == 0 ? this.variationImages.length - 1 : this.activeCarouselStep - 1
          }
          this.$nextTick(() => {
              if (myVar === null) return

              let hasPreviousSibling = myVar.previousSibling !== null;
              let hasNextSibling = myVar.nextSibling !== null;

              if (hasPreviousSibling) leftArrow.classList.add('d-flex')
              if (hasNextSibling) rightArrow.classList.add('d-flex')
          });
      },

    replaceSku(sku) {
      let otherLocale = this.locale === 'es' ? '-EN-' : '-ES-';

      return sku.replace(`-${this.locale.toUpperCase()}-`, otherLocale)
    },

  },
})
</script>

<style lang="scss">
@import 'https://cdn.jsdelivr.net/npm/vue3-carousel@0.2.9/dist/carousel.min.css';

.carousel__prev.carousel__prev--disabled {
    display: none;
}

.accordion-body,
.accordion-button {
    font-family: inherit;
}

.accordion-button:hover {
    color: inherit;
}
.space-section__item{
    display: flex;
    justify-content: center;
    width: 98%;
    margin: auto;
}
.space-section__cont{
    position: relative;
    &::before{
        position: absolute;
        content: '';
        top: 0;
        left: -1px;
        width: 3.8%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.563);
        z-index: 1;
    }
    &::after{
        position: absolute;
        content: '';
        top: 0;
        right: -1px;
        width: 3.8%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.563);
        z-index: 1;
    }
}
.carousel__next, .carousel__prev {
    z-index: 3;
}

</style>